@if (list.isHrProOrUpsellVisible()) {
  <decision-list-widget
    [title]="'Files to review' | translate"
    [state]="list.state()"
    [badgeLabel]="badgeLabel() | translate: { count: list.count() }"
    [clearMessage]="'Updated documents from employees show up here.' | translate"
    [errorMessage]="'We couldn\'t load your files to review.' | translate"
    [scopeLocation]="list.scopeLocation()"
    (retry)="list.reload()"
    (unlock)="list.openUpsell()"
  >
    @for (row of list.rows(); track row.attachmentId) {
      <li class="flex min-h-12 items-center gap-sm border-0 border-b border-solid border-default px-md py-sm">
        <span class="flex w-1/3 min-w-0 flex-none items-center gap-xs">
          <span class="min-w-0 truncate text-sm text-default" data-hj-suppress>{{ row.name }}</span>
          @if (row.isResubmission) {
            <sb-badge class="flex-none" color="yellow" size="xsmall" variant="pill" aria-hidden="true">{{
              '2nd' | translate
            }}</sb-badge>
            <span class="sr-only">{{ 'Resubmitted' | translate }}</span>
          }
        </span>
        <div class="flex min-w-0 flex-1 flex-col">
          <span class="text-sm wrap-break-word" data-hj-suppress>{{ row.title }}</span>
          <span class="text-xs text-subtle">{{
            'Uploaded [time]' | translate: { time: (row.uploadedAt | relativeDate) }
          }}</span>
        </div>
        @if (row.link; as link) {
          <span class="flex-none text-right"
            ><a class="text-sm font-semibold text-brand" [routerLink]="link"
              >{{ 'Open' | translate }} <span class="sr-only" data-hj-suppress>{{ row.name }} {{ row.title }}</span></a
            ></span
          >
        }
      </li>
    }
  </decision-list-widget>
}
